import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { InfoSpedizioniVini } from 'src/app/_classi/InfoSpedizioniVini';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';
import { VinoItem } from 'src/app/_classi/VinoItem';
import { CantinaService } from 'src/app/_servizi/cantina.service';
import { CarrelloViniService } from 'src/app/_servizi/carrelloVini.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-vini-vendibili-header',
  templateUrl: './vini-vendibili-header.component.html',
  styleUrls: ['./vini-vendibili-header.component.css']
})
export class ViniVendibiliHeaderComponent implements OnInit, OnChanges {

  @Input() vinoSelezionato: VinoItem;
  @Input() vini: VinoItem[];
  @Input() pacchetti: PacchettoItem[];

  @Output() filtra = new EventEmitter<any>();

  countCarrello = 0;

  filtroProdotto = null;
  prodotti = [
    { id: '0', label_traduzione: TRANSLATE('base.tutti'), label: 'Tutti', visible: true },
    { id: '6', label_traduzione: TRANSLATE('base.winebox'), label: 'WineBox', visible: true },
    { id: '1', label_traduzione: TRANSLATE('base.rosso'), label: 'Rosso', visible: true },
    { id: '2', label_traduzione: TRANSLATE('base.bianco'), label: 'Bianco', visible: true },
    { id: '3', label_traduzione: TRANSLATE('base.rosato'), label: 'Rosato', visible: true },
    { id: '4', label_traduzione: TRANSLATE('base.spumante'), label: 'Spumante', visible: true },
    { id: '5', label_traduzione: TRANSLATE('base.altri'), label: 'Altri prodotti', visible: true },
  ];

  prodottiVisibili = [];

  get infoSpedizioni(): InfoSpedizioniVini {
    return this.cantinaService.getInfoSpedizioniSconti();
  }

  constructor(
    private carrelloService: CarrelloViniService,
    private cantinaService: CantinaService,
    private router: Router,
    private messageService: MessageServiceService
  ) {

    this.carrelloService.nrRighe.subscribe((data) => {
      this.countCarrello = data;
    });
    this.caricaNrRigheCarrello();

  }

  ngOnChanges(changes: SimpleChanges): void {

    let i = 0;
    for (const prodotto of this.prodotti) {
      if (i != 0) {
        if (prodotto.label !== 'WineBox') {
          prodotto.visible = this.vini.filter(
            vino => vino.colore_id && vino.colore_id === prodotto.id
          ).length > 0 ? true : false;
        }
      }
      i++;
    }
    this.prodotti[1].visible = this.pacchetti && this.pacchetti.length > 0 ? true : false;
    this.prodottiVisibili = this.prodotti.filter(prodotto => prodotto.visible);

  }

  ngOnInit(): void {
  }

  filtraEmit() {
    this.filtra.emit(this.filtroProdotto);
  }

  goToCart() {
    this.router.navigateByUrl('/carrello/' + this.messageService.getIdCookie());
  }

  apriBooking() {
    if (this.countCarrello > 0) {
      this.messageService.apriBooking();
    }
  }

  caricaNrRigheCarrello() {
    this.carrelloService.checkCarrelloQta(null).subscribe();
  }

  isScontoValido() {
    const ora = moment();
    if (moment(this.infoSpedizioni.inizioPromo).isSameOrBefore(ora) && moment(this.infoSpedizioni.finePromo).isSameOrAfter(ora)) {
      return true;
    } else {
      return false;
    }
  }

}

function TRANSLATE(str: string) {
  return str;
}